import { render, staticRenderFns } from "./roomTopic.vue?vue&type=template&id=c6ed8cde&scoped=true&"
import script from "./roomTopic.vue?vue&type=script&lang=js&"
export * from "./roomTopic.vue?vue&type=script&lang=js&"
import style0 from "./roomTopic.vue?vue&type=style&index=0&id=c6ed8cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ed8cde",
  null
  
)

export default component.exports